import React, {Component} from 'react';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom'
import axios from 'axios';
import featuredBG from '../media/newgreybackground.jpg'


export default class FeaturedSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
    	featuredProductsArray: [],
    	featuredProductsLoaded: false
    };
  }

  componentDidMount() {
  	this.setFeaturedProductsState();
  }

  setFeaturedProductsState = () => {
    axios.get('https://s3.amazonaws.com/pattersonmaplefarmsstorage/products/info/FeaturedProducts.json')
      .then(response => {
        this.setState({
          featuredProductsArray: response.data
        }, () => this.setState({featuredProductsLoaded: true}) );
        
      })
      .catch(error => {
        console.log('Error fetching and parsing data', error);
      });
  }


  render() {
    //const ExampleObject = ( <div></div> );

    return (
	  <FluidContainer fluid>
	    <InternalContainer>
	      <h1>Check out our Featured Products</h1>
	      {this.state.featuredProductsLoaded 
	      	?
		  <DisplayRow>
			<Col xs="12" sm="6" lg="3">
				<Link to="/Shop/giftsets">
					<img src={this.state.featuredProductsArray[0].imgURL}></img>
				</Link>
			</Col>
			<Col xs="12" sm="6" lg="3">
				<Link to="/Shop/giftsets">
					<img src={this.state.featuredProductsArray[1].imgURL}></img>
				</Link>
			</Col>
			<Col xs="12" sm="6" lg="3">
				<Link to="/Shop/giftsets">
					<img src={this.state.featuredProductsArray[2].imgURL}></img>
				</Link>
			</Col>
			<Col xs="12" sm="6" lg="3">
				<Link to="/Shop/giftsets">
					<img src={this.state.featuredProductsArray[3].imgURL}></img>
				</Link>
			</Col>
		  </DisplayRow>
		  : "" }

		  <WordingRow>


			<Col xs="12" sm="12" md="12">
				<p>We offer a variety of different gift baskets and boxes which make the perfect gift for any occasion. 
				   There are so many yummy options. The baskets can also be customized upon request! Please feel free to check them out and let us know if you need
				   any assistance or recommendations.
				</p>
			</Col>

			<Col xs="12" style={{display: "flex", justifyContent: "center", marginTop: "30px"}}>
			  	<Link to="/Shop/giftsets">
				  	<ShopGiftBasketButton>
						<p>Shop Gift Baskets</p>
					</ShopGiftBasketButton>
			  	</Link>
			  	<LeavesImg src={require("../media/leavespng1.png")}></LeavesImg>
			</Col>
		  </WordingRow>


		  
	    </InternalContainer>
	  </FluidContainer>

		);
	}
}

const LeavesImg = styled.img`
	width: auto!important;
	height: auto!important;
	max-height: 40px!important;
	${media.md`max-height: 50px!important;`}
	position: absolute!important;
	right: 0;
`;

const DisplayRow = styled(Row)`
	.col-12 {
		margin-bottom: 15px;
		${media.sm` margin-bottom: 30px; `} 
		${media.lg` margin-bottom: 15px; `} 
		transition: all 0.5s;
		:hover { transform: translateY(6px); }

		img {
			width: 90%;
			${media.sm` width: 100%;`}
			height: auto;
		}
	}
`;

const WordingRow = styled(Row)`
	margin-top: 10px;

	.col-12, .col-3 {
		img {
			width: 100%;
			height: auto;
			max-width: 100px;
			max-height: 90px;
			position: relative;
			top: 50%;
			transform: translateY(-50%);
			${media.lg` width: 90px; height: 80px;`}
		}
		p {
			color: black;
			text-align: left;
			margin: 0;
		}
	}
`;

const FluidContainer = styled(Container)`
	padding: 20px 0 20px 0!important;
	background-image: url(${featuredBG}); 
`;
const InternalContainer = styled(Container)`
	text-align: center;
	h1 { 
		color: black; 
		margin: 0 0 20px 0;
	}
`;

const ShopGiftBasketButton = styled(Button)`
  cursor: pointer;
  display: block;
  border: 0px!important;
  color: white!important;
  font-weight: bold!important;
  background-color: #800000!important;
  width: 240px;
  ${media.sm` width: 250px; `}
  ${media.md` width: 290px; `}
  height: 40px;
  line-height: 20px!important;
  transition: all 0.5s;
  margin: 0 auto;

  p {
    cursor: pointer;
    display: inline;
    position: relative;
    transition: 0.5s;
    color: white!important;
  }

  p:after {
    content: '\00bb';
    position: absolute;
    opacity: 0;
    right: -20px;
    transition: 0s;
  }

  :hover p { padding-right: 25px; }
  :hover p:after { opacity: 1; right: 0; }
  :active p:after { opacity: 0; }
  :active { box-shadow: 0 5px #666; transform: translateY(6px); }
`;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
  display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/


// WEBPACK FOOTER //
// ./src/components/FeaturedSection.js